import { useEffect, useState } from 'react'

// Flutter InAppWebView type declarations
declare global {
  interface Window {
    flutter_inappwebview?: {
      callHandler: (handlerName: string, ...args: any[]) => Promise<any>
    }
  }
}

/**
 * Custom hook for Flutter InAppWebView integration
 * Handles platform readiness detection
 *
 * @returns isFlutterReady flag
 */
export const useFlutterInAppWebView = () => {
  const [isFlutterReady, setIsFlutterReady] = useState(false)

  useEffect(() => {
    const checkAndSetReady = () => {
      if (window.flutter_inappwebview && typeof window.flutter_inappwebview.callHandler === 'function') {
        console.log('Flutter InAppWebView is ready!')
        setIsFlutterReady(true)
        return true
      }
      return false
    }

    const handleFlutterReady = function () {
      console.log('Flutter InAppWebView platform ready event fired!')
      checkAndSetReady()
    }

    // Check if already ready (event might have fired before component mounted)
    if (checkAndSetReady()) {
      return
    }

    // Listen for platform ready event
    window.addEventListener('flutterInAppWebViewPlatformReady', handleFlutterReady)

    return () => {
      window.removeEventListener('flutterInAppWebViewPlatformReady', handleFlutterReady)
    }
  }, [])

  return { isFlutterReady }
}
